module.exports = __webpack_public_path__ + "static/img/company.e5e0dbb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/company.jpg
// module id = d1eR
// module chunks = 12